import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

// import { OrganizationsStoreModule } from '@shure/cloud-apps/organizations/store';

import {
	PrismIconButtonComponent,
	PrismIconComponent,
	PrismMenuComponent,
	PrismMenuItemComponent
} from '@shure/prism-angular-components';

import { FooterComponent } from './footer.component';

@NgModule({
	declarations: [FooterComponent],
	exports: [FooterComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		RouterModule,
		TranslocoModule,
		PrismIconButtonComponent,
		PrismMenuComponent,
		PrismMenuItemComponent,
		PrismIconComponent
		// OrganizationsStoreModule
	]
})
export class FooterModule {}
